// Port of api/fuel/app/classes/filter/search/games/rules/query/bgg_owners.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'bgg_owners',
	field: function() { return 'g.game_own' }
})
